module.exports = require('./helpers/bundle-url').getBundleURL('9R8Ou') + "logo-dark.eefe0b7f.svg";